<template>
  <div>
    <div class="tables">
       <div>
          <el-button type="primary" @click="goBack">返回</el-button>
        </div>
      <el-card class="table box-card">
        <h3 slot="header">原料信息</h3>
        <el-table size="mini" ref="multipleTable" :data="materialList" show-summary :summary-method="getSummaries"
          style="width: 100%;overflow:visible;" class="elTab" @selection-change="handleSelectionChange"
          @row-click="dianjixuanzhong" highlight-current-row
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column prop="cargoBarcode" label="原料捆包号"></el-table-column>
          <el-table-column prop="productName" label="原料品种"></el-table-column>
          <el-table-column prop="model" label="原料材质"></el-table-column>
          <el-table-column prop="specification" label="原料规格"></el-table-column>
          <el-table-column prop="steelMillName" label="原料产地"></el-table-column>
          <el-table-column prop="number" label="件数/张数"></el-table-column>
          <el-table-column prop="weight" label="原料重量（吨）"></el-table-column>
        </el-table>
      </el-card>
      <el-card class="table box-card">
        <h3 slot="header">成品信息</h3>
        <el-table size="mini" ref="table1" show-summary :summary-method="getSummaries1"
          style="width: 100%;overflow:visible;" :data="entrustMaterial" class="elTab"
          @selection-change="handleSelectionChange" :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column prop="cargoBarcode" label="成品捆包号" width="200"></el-table-column>
          <el-table-column prop="processingTechnologyName" label="加工工艺"></el-table-column>
          <el-table-column prop="checkProductName" label="成品品种"></el-table-column>
          <el-table-column prop="model" label="成品材质"></el-table-column>
          <el-table-column prop="checkSpecification" width="100" label="成品规格"></el-table-column>
          <el-table-column prop="checkNumber" label="成品数量"></el-table-column>
          <el-table-column prop="checkWeight" label="成品重量（吨）" width="120"></el-table-column>
          <el-table-column prop="checkRequirementsName" label="包装方式"></el-table-column>
          <el-table-column prop="checkPutName" label="摆放要求"></el-table-column>
          <el-table-column prop="checkWeighingMethodName" label="计量方式"></el-table-column>
          <el-table-column prop="productionEquipmentName" label="加工产线" width="200"></el-table-column>
          <el-table-column prop="mainOperator" label="主操人员"></el-table-column>
          <el-table-column prop="acceptancePerson" label="验收人员"></el-table-column>
          <el-table-column property="acceptanceDate" label="验收时间" width="200" :formatter="dateTimeFormat">
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getEntrustMaterialList,
  getProductChecklList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'

export default {
  name: 'reportDetail',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      materialList: [],
      entrustMaterial: [],
      xuanzhongArr: [],
      multipleTable: []
    }
  },
  mounted () {
    console.log(this.$route.query)
    this.getEntrustMaterialLists()
  },
  methods: {
    getSummaries (param) {
      const {
        columns,
        data
      } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          // 如果是最后一列，索引为列数-1，则显示计算总和
        } else if (index === 7) {
          const values = data.map((item) => Number(item[column.property])) // [33,22]
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (column.property == 'checkNumber') {
              sums[index] = sums[index].toFixed(0)
            } else {
              sums[index] = sums[index].toFixed(3)
            }
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    },
    getSummaries1 (param) {
      const {
        columns,
        data
      } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          // 如果是最后一列，索引为列数-1，则显示计算总和
        } else if (index === 7) {
          const values = data.map((item) => Number(item[column.property])) // [33,22]
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (column.property == 'checkNumber') {
              sums[index] = sums[index].toFixed(0)
            } else {
              sums[index] = sums[index].toFixed(3)
            }
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    },
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = [row]
      this.getProductChecklLists(row)
    },
    handleSelectionChange (row) {
      console.log(row)
    },
    goBack () {
      this.$router.go(-1)
    },
    getEntrustMaterialLists () {
      // machiningNoticeId
      if (this.$route.query.machiningEntrustId !== undefined) {
        getEntrustMaterialList({
          machiningEntrustId: this.$route.query.machiningEntrustId
        })
          .then(res => {
            this.materialList = res
            if (res.length != 0) {
              this.xuanzhongArr = [res[0]]
              this.getProductChecklLists(res[0])
              setTimeout(() => {
                this.$refs.multipleTable.setCurrentRow(this.xuanzhongArr[0])
              }, 0)
            }
          })
          .catch(err => {
            console.log(err)
            DonMessage.error(err.message)
          })
      } else {
        getEntrustMaterialList({
          machiningNoticeId: this.$route.query.machiningNoticeId
        })
          .then(res => {
            this.materialList = res
            if (res.length != 0) {
              this.xuanzhongArr = [res[0]]
              this.getProductChecklLists(res[0])
              setTimeout(() => {
                this.$refs.multipleTable.setCurrentRow(this.xuanzhongArr[0])
              }, 0)
            }
          })
          .catch(err => {
            console.log(err)
            DonMessage.error(err.message)
          })
      }
    },
    getProductChecklLists (row) {
      console.log(row)
      getProductChecklList({
        entrustMaterialIds: row.entrustMaterialId,
        notFalfProduct: this.$route.query.yanshou ? this.$route.query.yanshou : null
      })
        .then(res => {
          this.entrustMaterial = res
        })
        .catch(err => {
          console.log(err)
          DonMessage.error(err.message)
        })
    }
  }
}

</script>

<style lang="less" scope>
  .topBack {
    position: fixed;
    top: 46px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: #fff;
    z-index: 1111;
    padding-left: 20px;
    overflow: hidden;
  }

  .tables {
    width: 100%;
  }

  /deep/ .box-card {
    margin-bottom: 20px;
  }

  .el-card__body {
    padding: 0px 10px;

    /deep/ .el-table {
      overflow: auto !important;
    }
  }

  /deep/ .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 5px 0;
  }

</style>
